import axios from 'axios';
import AppConfig from '../../AppConfig';
import { axiosBaseConfig, setupInterceptors } from './baseAxiosInstance';

const claimsAxiosInstance = axios.create({
  ...axiosBaseConfig,
  baseURL: AppConfig.CLAIMS_BASE_URL as string,
});

setupInterceptors(claimsAxiosInstance);

export default claimsAxiosInstance;
